<template>
  <div v-show="isPWAinBrowser && showInstallPrompt" class="p-1">
    <div class="android-install-prompt" v-if="!isIos">
      <article class="media mb-1">
        <figure class="media-left" v-if="showLogo">
          <p class="image is-48x48">
            <img class="is-rounded" src="@/assets/hafta8-logo-s.png" />
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <strong class="has-text-white">Hiçbir etkinliği kaçırma</strong>
            <p class="is-size-14px">Hafta8 web uygulaması ile etkinlikler her zaman elinin altında.</p>
          </div>
        </div>
      </article>
      <div class="buttons">
        <button
          @click="isPWAinBrowser = false"
          @click.native="$analytics.logEvent('install_banner', { button_name: 'not_now', page_name: $route.name})"
          class="ml-auto button is-rounded is-small is-primary"
        >Daha Sonra</button>
        <button
          @click="installPrompt"
          @click.native="$analytics.logEvent('install_banner', { button_name: 'add_to_home_screen', page_name: $route.name})"
          class="button is-primary is-inverted is-rounded is-small"
        >Ana Ekrana Ekle</button>
      </div>
    </div>

    <div class="ios-install-prompt" v-else>
      <article class="media mb-0">
        <figure class="media-left" v-if="showLogo">
          <p class="image is-48x48">
            <img class="is-rounded" src="@/assets/hafta8-logo-s.png" />
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <strong class="has-text-white">Hiçbir etkinliği kaçırma</strong>
            <p class="is-size-14px">Hafta8 web uygulaması ile etkinlikler her zaman elinin altında.</p>
            <div class="is-size-14px">
              <span>
                Önce
                <img
                  style="height: 16px; margin: 0 2px; filter: invert(100%)"
                  src="@/assets/Navigation_Action_ios.png"
                  alt="apple_action_button"
                />
                butonuna daha sonra
                <strong class="has-text-white">'Ana Ekrana Ekle'</strong> butonuna tıkla.
              </span>
            </div>
          </div>
        </div>
      </article>
      <!-- <div class="buttons">
        <button
          @click="showInstallPrompt = false"
          class="ml-auto button is-rounded is-small"
        >Daha Sonra</button>
        <button @click="installPrompt" class="button is-rounded is-small">Ana Ekrana Ekle</button>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showLogo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // installPrompt: null
      showInstallPrompt: true,
      isPWAinBrowser: true,
      isIos: false
    };
  },
  methods: {
    installPrompt() {
      const deferredPrompt = this.$store.state.ui.deferredInstallPrompt;
      // console.log('install promprt', this.$store.state.ui.deferredInstallPrompt);

      deferredPrompt.prompt();
      let vm = this;
      deferredPrompt.userChoice.then(choiceResult => {
        console.log("app install choice result", choiceResult);
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
          this.isPWAinBrowser = false

          this.$analytics.logEvent('install_banner', { choice_result: 'accepted', page_name: this.$route.name})

          localStorage.setItem('is_app_installed', true)

        } else {
          // this.isPWAinBrowser = false
          console.log("User dismissed the A2HS prompt");
          this.$analytics.logEvent('install_banner', { choice_result: 'dismissed'})
        }
        this.deferredPrompt = null;
      });
    }
  },
  created() {


    const isAppInstalled = localStorage.getItem('is_app_installed')

    if (isAppInstalled) {
      this.showInstallPrompt = false
    }

    let vm = this
    // before install prompt
    window.addEventListener("beforeinstallprompt", e => {
      // console.log("before install prompt", e);

      vm.$analytics.logEvent('install_banner', { install_prompt_avaliable: true, page_name: this.$route.name})
      if (process.env.NODE_ENV === "development") {
        console.log("before install prompt");
      }
      e.preventDefault();
      // Stash the event so it can be triggered later.
      vm.$store.commit("ui/SET_INSTALL_PROMPT", e);
    });

    // app isntalled listener
    window.addEventListener("appinstalled", evt => {
      if (process.env.NODE_ENV === "development") {
        console.log("appinstalled evt:", evt);
      }
      if (evt.outcome === "accepted") {
        this.isPWAinBrowser = false
      }

      if (process.env.NODE_ENV === "development") {
        console.log("a2hs installed");
      }
    });

    // replace standalone with fullscreen or minimal-ui according to your manifest
    // console.log("1)isPWAinBrowser", this.isPWAinBrowser);
    if (matchMedia("(display-mode: standalone)").matches) {
      // Android and iOS 11.3+
      this.isPWAinBrowser = false;
    } else if ("standalone" in navigator) {
      // useful for iOS < 11.3
      this.isPWAinBrowser = !navigator.standalone;
      // this.showInstallPrompt = !isInStandaloneMode();
    }

    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };

    // console.log("is ios", isIos());
    this.isIos = isIos();
  }
};
</script>

<style>
</style>